/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Notification à afficher (message de succès)
 * @export
 * @interface HbsConfirmUploadResponseNotification
 */
export interface HbsConfirmUploadResponseNotification {
    /**
     * Corps de la notification
     * @type {string}
     * @memberof HbsConfirmUploadResponseNotification
     */
    message?: string;
    /**
     * Titre optionnel de la notification
     * @type {string}
     * @memberof HbsConfirmUploadResponseNotification
     */
    title?: string | null;
}

/**
 * Check if a given object implements the HbsConfirmUploadResponseNotification interface.
 */
export function instanceOfHbsConfirmUploadResponseNotification(value: object): value is HbsConfirmUploadResponseNotification {
    return true;
}

export function HbsConfirmUploadResponseNotificationFromJSON(json: any): HbsConfirmUploadResponseNotification {
    return HbsConfirmUploadResponseNotificationFromJSONTyped(json, false);
}

export function HbsConfirmUploadResponseNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): HbsConfirmUploadResponseNotification {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function HbsConfirmUploadResponseNotificationToJSON(json: any): HbsConfirmUploadResponseNotification {
    return HbsConfirmUploadResponseNotificationToJSONTyped(json, false);
}

export function HbsConfirmUploadResponseNotificationToJSONTyped(value?: HbsConfirmUploadResponseNotification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'title': value['title'],
    };
}

